function DeleteCell({ dataItem, onDelete }) {
    function handleDelete() {
        onDelete(dataItem.id);
    };

    return (
        <td>
            <span className="text-danger float-right">
                <i onClick={handleDelete} className="fal fa-times"></i>
            </span>
        </td>
    );
}

export default DeleteCell;